module.exports = __webpack_public_path__ + "img/logo-smartfit.85109fca.png";